<template>
  <div class="block">
    <el-carousel trigger="click" height="450px">
      <el-carousel-item v-for="lineItem in item.order_line_print" :key="lineItem">
        <div class="carousel-item-container">
          <div class="carousel-item-image" v-if="lineItem.files.length">
            <a title="Open in new tab" :href="lineItem.files[0].url" target="_blank">
              <img v-bind:src="lineItem.files[0].url" />
            </a>
          </div>
          <div class="carousel-item-caption">
            <div v-if="lineItem.files.length"><span>Type:</span> {{ lineItem.files[0].file_type.name }}</div>
            <div><span>Position:</span> {{ lineItem.position }}</div>
            <div><span>X Offset: </span> {{ lineItem.x_offset ? lineItem.x_offset : 'N/A' }}</div>
            <div><span>Y Offset: </span> {{ lineItem.y_offset ? lineItem.y_offset : 'N/A' }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
  <div class="w-full p-6">
    <div class="mt-5">
      <span class="font-semibold">#{{ item.id }}</span>
      <div class="mt-5">
        <div>
          <span class="font-semibold">Sku: </span><span>{{ item.sku }}</span>
        </div>
        <div>
          <span class="font-semibold">Quantity: </span><span>{{ item.quantity }}</span>
        </div>
        <div>
          <span class="font-semibold">Status: </span><span>{{ item.status || 'N/A' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { OrderLineClientModel } from '../models/client/order-line.client.model';

export default defineComponent({
  name: 'item-detail',
  props: {
    item: OrderLineClientModel,
  },
});
</script>

<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

::v-deep(img) {
  max-height: 300px;
}

.carousel-item-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;
}

.carousel-item-caption {
  background: #bdc8d;
  width: 100%;
  min-hegiht: 100px;
  bottom: -120px;
  padding: 10px;
  position: absolute;
  left: 0;
  text-align: center;
  text-transform: capitalize;
}

.carousel-item-image {
  background: white;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
